const ATTENTION_LABELS: Readonly<Record<string, string>> = {
  L1: "RFQ response overdue",
  L2: "Approved PO awaiting send",
  L3: "Stalled purchase-order tracker",
  L4: "Delivered PO awaiting closure",
  L5A: "PO approval pending",
  L5B: "Rejected PO awaiting action",
  L6: "Accepted requisition without RFQ or PO",
  L7: "Overdue unpaid invoice",
  L8: "RFQ email pending or failed",
  L9: "Open dispute older than seven days",
  L10: "Delivery past expected date",
  L11: "RFQ awaiting PO",
  L12: "RFQ response due soon",
  L13: "Awarded quotation expiring",
  L14: "Draft PO without recent activity",
  L15: "Over-delivered GRN lines",
  L16: "Vendor certificate expired",
  L17: "Broken delegation coverage",
  L18: "Emergency requisition awaiting review",
  L19: "Cancelled PO with unpaid invoice",
  L20: "Cleared invoice awaiting closure",
  "INV-01": "Negative unpaid invoice balance",
  "INV-11": "Bank detail missing an audit witness",
  "INV-12": "Exchange rate missing an audit witness",
  "INV-13": "Recovery decision missing an audit witness",
  "INV-02": "Cancelled requisition with open RFQ or PO",
  "INV-14": "Requisition ready for closure",
  "INV-16": "Rejected requisition line without a reason",
  "INV-17": "Overlapping active budget periods",
  "INV-18": "Active budget unreachable by the resolver",
  "INV-04": "Public-site debug page",
};

const REGISTER_ROOTS = new Set(["/requisitions", "/rfqs", "/purchase-orders", "/invoices", "/disputes", "/grns", "/vendors", "/exchange-rates", "/budget/recovery", "/budget/plan"]);

export function getAttentionRegisterRequestedVessel(
  pathname: string,
  searchParams: Pick<globalThis.URLSearchParams, "get">,
): string | null {
  const path = pathname.replace(/\/+$/, "");
  const attention = searchParams.get("attention")?.trim();
  const grnRead = /^\/grns\/[^/]+$/.test(path) && attention?.toUpperCase() === "L15";
  if ((!REGISTER_ROOTS.has(path) && !grnRead) || !attention) return null;
  return searchParams.get("vessel_id")?.trim() || null;
}

export function attentionRegisterLabel(identifier: string): string {
  return `Attention: ${ATTENTION_LABELS[identifier.toUpperCase()] ?? identifier}`;
}

/** Attention requires current server evidence, which ordinary offline caches lack. */
export function requireOnlineAttentionRegister(attention: string | undefined): void {
  if (attention?.trim() && typeof navigator !== "undefined" && !navigator.onLine) {
    throw new Error("Connect to the internet to load the attention filter.");
  }
}

/** Final query-key field carries attention; never relabel previous rows as its results. */
export function preservePreviousAttentionRegisterData<T>(
  previousData: T | undefined,
  previousQueryKey: readonly unknown[] | undefined,
  attention: string,
): T | undefined {
  const previousScope = previousQueryKey?.[previousQueryKey.length - 1];
  const previousAttention = previousScope && typeof previousScope === "object" && "attention" in previousScope
    ? previousScope.attention
    : undefined;
  return attention || previousAttention ? undefined : previousData;
}
